var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"background"}},[_c('header-nav',{on:{"showComponent":function($event){return _vm.showComponent()}}}),_c('br'),_c('br'),_c(_vm.selectedComponent,{tag:"component",staticStyle:{"margin-top":"20px","margin-left":"20px","margin-right":"20px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }